import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import RedFlags from "./components/RedFlags";
import Compare from "./components/Compare";
import Steps from "./components/Steps";
import Tactics from "./components/Tactics";
import Checklist from "./components/Checklist";
import Myths from "./components/Myths";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  useEffect(() => {
    document.title =
      "吃瓜官网真假识别：仿冒与防伪避坑全攻略｜辨真识别指南";
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <RedFlags />
        <Compare />
        <Steps />
        <Tactics />
        <Checklist />
        <Myths />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}